import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Store } from '@ngxs/store';
import { AcademicYearState } from '../academic-year/academic-year.state';
import { IApplicationContent } from '../types/content.type';
import { DotNetDatePipe } from '../pipes/dot-net-date.pipe';

export function TooYoungValidator(index: number, content: IApplicationContent, store: Store, dotnetdatepipe: DotNetDatePipe): ValidatorFn {
	return (control: AbstractControl) => {
		let validAge = true;

		const selectedAY = store.selectSnapshot(AcademicYearState.selectedYear);

		const monthEle = document.getElementById('childBirthMonth' + index);
		const dayEle = document.getElementById('childBirthDay' + index);
		const yearEle = document.getElementById('childBirthYear' + index);

		if (!selectedAY || !monthEle || !dayEle || !yearEle) {
			return null;
		}

		const isCurrentAcademicYear = selectedAY === content.currentAcademicYear;
		const month = (monthEle as any).value;
		const day = (dayEle as any).value;
		const year = (yearEle as any).value;
		const gradeLevel = control.value;

		if (month && day && year && gradeLevel) {
			const childBirthDate = new Date(year, month - 1, day);
			const currentK_Deadline =  dotnetdatepipe.transform(content.currentKindergartenDOB_Deadline);
			const nextK_Deadline = dotnetdatepipe.transform(content.nextKindergartenDOB_Deadline);
			const currentFirst_Deadline = dotnetdatepipe.transform(content.currentFirstGradeDOB_Deadline);
			const nextFirst_Deadline = dotnetdatepipe.transform(content.nextFirstGradeDOB_Deadline);

			if (
				(isCurrentAcademicYear && currentK_Deadline !== null && currentK_Deadline < childBirthDate) ||
				(!isCurrentAcademicYear && nextK_Deadline !== null && nextK_Deadline < childBirthDate)
			) {
				validAge = false;
			} else if (gradeLevel !== 1 && gradeLevel !== 323 && gradeLevel !== 399 && gradeLevel !== 403) {
				if (
					(isCurrentAcademicYear && currentFirst_Deadline != null && currentFirst_Deadline < childBirthDate) ||
					(!isCurrentAcademicYear && nextFirst_Deadline != null && nextFirst_Deadline < childBirthDate)
				) {
					validAge = false;
				}
			}
		} else {
			return null;
		}

		if (!validAge) {
			return { tooYoungToApply: true };
		} else {
			return null;
		}
	};
}
